







































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import PageTitle from '@/components/common/PageTitle.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import SequenceList from '@/components/manage/inquiry/SequenceList.vue';
const mallModule = namespace('mall');
import {
  PostInquiryTypeRequest,
  PutInquiryTypesInquiryTypeNoOrderRequest,
  GetInquiryTypeRequest,
  DeleteInquiryTypesInquiryTypeNoRequest,
  GetInquiryTypesInquiryTypeNoRequest,
  GetInquiryTypesInquiryTypeNo,
  PutInquiryTypesInquiryTypeNoRequest,
  InquiryType,
  MallAuthority,
  Assignees,
  Mall
} from 'supporter';
import {AdminsServiceMallAuthorityRequest} from 'ncp-api-supporter/dist/types';
@Component({
  components: {
    PageTitle,
    MallsTab,
    CompSelectBox,
    SequenceList
  }
})
export default class TypeConfig extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private inquirTypes: InquiryType[] = [];
  private inquirIndex: number = 0;
  private admins: MallAuthority[] = [];

  private tmpInquirDetail: GetInquiryTypesInquiryTypeNo = {
    description: '',
    channel: '',
    no: -1,
    assignees: [{name: '',id: '',no: undefined}],
    name: ''
  };

  private addTypeTree(): any {
    let obj: InquiryType = {
      name: this.$t('INQUIRY_TYPE_NAME_PLACEHOLDER').toString(),
      no: -1,
      channel: '',
      assignees: [
      ]
    };
    this.inquirTypes.push(obj);
  }

  private onClickRemoveBtn() {
    if (this.inquirTypes.length === 0) {
      alert(this.$t('INQUIRY_TYPE_WARN_LENGTH'));
      return;
    }

    if (this.inquirTypes[this.inquirIndex].channel === 'NAVER_PAY') {
      alert(this.$t('INQUIRY_TYPE_WARN_TYPECHANNEL'));
      return;
    }

    if (confirm('' + this.$t('INQUIRY_TYPE_CONFIRM_DEL'))) {
      this.doDeleteBoard(this.inquirIndex);
    }
  }

  private doDeleteBoard(index: number): void {
    let inquiryTypeNo = this.inquirTypes[index].no;
    if (inquiryTypeNo <= 0) {
      this.inquirTypes.splice(index, 1);
    } else {
      let request: DeleteInquiryTypesInquiryTypeNoRequest = {
        pathParams: {
          inquiryTypeNo: inquiryTypeNo.toString()
        },
        params: {
          mallNo: this.mallNo
        }
      };
      this.$api
        .deleteInquiryTypesInquiryTypeNo(request)
        .then((): void => {
          this.getInquirTypes();
        })
        .catch((): void => {});
    }
  }

  private onOrderUp(index: number): void {
    if (index > 0) {
      if (this.inquirTypes[index].no > 0) {
        // order 변경 시 sequence를 0부터가 아닌 1부터 수정하도록 변경
        this.doChangeInquirOrder(index, +1);
      }
    }
  }
  private onOrderDown(index: number): void {
    if (index < this.inquirTypes.length - 1) {
      if (this.inquirTypes[index].no > 0) {
        // order 변경 시 sequence를 0부터가 아닌 1부터 수정하도록 변경
        this.doChangeInquirOrder(index, -1);
      }
    }
  }

  private doChangeInquirOrder(index: number, step: number): void {
    let reverseIndex = this.inquirTypes.length - index - 1;
    let request: PutInquiryTypesInquiryTypeNoOrderRequest = {
      pathParams: {
        inquiryTypeNo: this.inquirTypes[index].no.toString()
      },
      data: {
        newOrder: reverseIndex + step,
        mallNo: this.mallNo
      }
    };
    this.$api
      .putInquiryTypesInquiryTypeNoOrder(request)
      .then(() => {
        this.getInquirTypes();
      })
      .catch(() => {});
  }

  private onLabelNameChange(name: string): void {
    if (this.inquirTypes[this.inquirIndex].channel === 'NAVER_PAY') {
      return;
    }
    this.tmpInquirDetail.name = name;
  }

  private onItemSelect(index: number): void {
    this.inquirIndex = index;
    if (this.inquirIndex >= 0) {
      if (this.inquirTypes[this.inquirIndex].no > 0) {
        this.refreshGradeDetail(this.inquirIndex);
      } else {
        this.tmpInquirDetail = {
          description: '',
          channel: '',
          no: -1,
          assignees: [
            {
              name: '',
              id: '',
              no: undefined,
            }
          ],
          name: ''
        };
      }
    }else{
          this.tmpInquirDetail = {
          description: '',
          channel: '',
          no: -1,
          assignees: [
            {
              name: '',
              id: '',
              no: undefined,
            }
          ],
          name: ''
        };
    }
    this.getAdmins();
  }

  private refreshGradeDetail(index: number): void {
    let request: GetInquiryTypesInquiryTypeNoRequest = {
      pathParams: {
        inquiryTypeNo: this.inquirTypes[index].no.toString()
      },
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getInquiryTypesInquiryTypeNo(request).then((ret): void => {
      this.tmpInquirDetail = ret.data;
      if(!this.tmpInquirDetail.assignees || this.tmpInquirDetail.assignees.length ==0){
        this.tmpInquirDetail.assignees = [{
              id: '',
              name: '',
              no: undefined,
            }]
      }
    });
  }

  private addAssignees(): void {
    let newAssigness: Assignees = {
      name: '',
      id: '',
      no: undefined,
    };
    this.tmpInquirDetail.assignees.push(newAssigness);
  }

  private delAssignees(index: number): void {
    this.tmpInquirDetail.assignees.splice(index, 1);
  }

  private doSetting(): void {
    if (this.tmpInquirDetail.name === '') {
      alert(this.$t('INQUIRY_TYPE_WARM_TYPENAME'));
      return;
    }

    if (this.tmpInquirDetail.assignees.length == 0) {
      alert(this.$t('INQUIRY_TYPE_WARM_ADMINS', [this.tmpInquirDetail.name]));
      return;
    }

    if (!this.tmpInquirDetail.assignees.find(assignee => assignee && assignee.no && assignee.no > 0)) {
      alert(this.$t('INQUIRY_TYPE_WARM_ADMINS', [this.tmpInquirDetail.name]));
      return;
    }

    if (confirm('' + this.$t('INQUIRY_TYPE_CONFIRM_SAVE'))) {
      if (this.tmpInquirDetail.no <= 0) {
        this.doAddInquiry();
      } else {
        this.doModifyInquirDetail();
      }
    }
  }

  private getAssigneeNos(assignees: Assignees[]) {
    let ret = '[';
    if (assignees && assignees.length > 0) {
      assignees.every(assignee => {
        ret += assignee.no + ', ';
      });
      ret.slice(ret.length - 1, 2);
    }
    return (ret += ']');
  }

  private doAddInquiry(): void {
    let request: PostInquiryTypeRequest = {
      data: {
        mallNo: this.mallNo,
        inquiryTypeName: this.tmpInquirDetail.name,
        inquiryTypeDescription: this.tmpInquirDetail.description,
        // assigneeNos: this.getAssigneeNos(this.tmpInquirDetail.assignees),
        assigneeNos: this.tmpInquirDetail.assignees.filter(assignee =>  assignee.no).map(assignee =>  assignee.no)
        // assigneeNos: this.tmpInquirDetail.assignees.map(assignee => {if(assignee.no){assignee.no}}).join(',') // 타입이 string이던데 원하는 형태가 이 형태일까요?
      }
    };

    this.$api
      .postInquiryTypes(request)
      .then((): void => {
        alert(this.$t('INQUIRY_TYPE_SUCCESS_MOD'));
        this.getInquirTypes();
      })
      .catch((): void => {});
  }

  private doModifyInquirDetail(): void {
    let request: PutInquiryTypesInquiryTypeNoRequest = {
      pathParams: {
        inquiryTypeNo: this.tmpInquirDetail.no.toString()
      },
      data: {
        mallNo: this.mallNo,
        inquiryTypeName: this.tmpInquirDetail.name,
        inquiryTypeDescription: this.tmpInquirDetail.description,
        assigneeNos: this.tmpInquirDetail.assignees.filter(assignee =>  assignee.no).map(assignee =>  assignee.no)
        
      }
    };

    this.$api.putInquiryTypesInquiryTypeNo(request).then(() => {
      alert(this.$t('INQUIRY_TYPE_SUCCESS_MOD'));
      this.getInquirTypes();
    });
  }

  private async getInquirTypes() {
    const templateRequest: GetInquiryTypeRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    const result = await this.$api.getInquiryType(templateRequest);
    this.inquirTypes = result.data;

    this.inquirIndex = this.inquirTypes && this.inquirTypes.length ? 0 : -1;
    this.onItemSelect(this.inquirIndex);
  }

  private async getAdmins() {
    const authRequest: AdminsServiceMallAuthorityRequest = {
      params: {
        mallNo: this.mallNo,
        includeMaster: true,
      }
    };
    const result = await this.$api.getAdminsServiceMallAuthority(authRequest);
    this.admins = [...result.data]
      .sort((a,b)=>a.name>b.name?1:-1)
      .map(({id, no , role, name})=>({
      id,
      no,
      role,
      name: `${name}(${id})`
    }))
  }

    private lengthInUtf8Bytes(str) {
        let m = encodeURIComponent(str).match(/%[89ABab]/g);
        return str.length + (m ? m.length : 0);
    }

  private getWordCount(msg, maxByte): number[]{
      let letter;
      let msgByte = 0;
      let msgLength = 0;
      const obj = [];

      for (let i = 0; i < msg.length; i++) {
          letter = msg.charAt(i);
          msgByte += this.lengthInUtf8Bytes(letter);

          msgLength += 1;
          if (msgByte >= maxByte) {
              obj[0] = msgLength;
              obj[1] = msgByte;
              // obj[1] = maxByte;

              return obj;
          }
      }
      obj[0] = msgLength;
      obj[1] = msgByte;

      return obj;
  }

  private onChangeContent(msg, maxByte): void {
    this.tmpInquirDetail.description = this.tmpInquirDetail.description.substring(0, this.getWordCount(msg, maxByte)[0])
  }

  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
     await this.getInquirTypes();

  }

  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.getInquirTypes();
  }
}
